import FirebaseModel from "@/Store/ORM/FirebaseORM/FirebaseModel";

export default class BillingBundleDiscount extends FirebaseModel {
	static entity = 'billingBundleDiscounts';
	static baseCollection = this.firestore.collection('Configs').doc('Belit').collection('bundle_discounts');
	static fields(){
		return {
			name: this.attr(null),
			condition: this.attr(null),
			count: this.number(null),
			discount: this.number(0),
			allowed_categories: this.attr(false),
			allowed_tests: this.attr(false),
			excluded_promotions: this.attr(false),
			has_tests: this.attr(null),
			priority: this.attr(null),
			...super.fields()
		}
	}
}
